import { useDispatch, useSelector } from 'react-redux'
import { selectIsSoloRea } from 'src/store/selectors/customerProfile'
import { selectClientIsGuest } from 'src/store/selectors/client'
import { YourHomeLink } from './YourHomeLink'
import { FindAHomeLink } from './FindAHomeLink'
import { setMobileNavIsOpen } from 'src/store/slices/navbar'
import { toggleAuthModal } from 'src/actions/homeSearchAuthModal'
import { AuthButtons } from './AuthButtons'

import styles from './MobileHeaderModalBody.module.scss'

export const MobileHeaderModalBody = () => {
  const dispatch = useDispatch()

  const isSoloRea = useSelector(selectIsSoloRea)
  const isGuest = useSelector(selectClientIsGuest)

  const handleButtonClick = () => {
    dispatch(toggleAuthModal(true))
    dispatch(setMobileNavIsOpen(false))
  }
  return (
    <>
      <YourHomeLink />
      {!isSoloRea && (
        <>
          <div className={styles.border} />
          <FindAHomeLink />
        </>
      )}
      {isGuest && (
        <>
          <div className={styles.border} />
          <AuthButtons onClick={handleButtonClick} />
        </>
      )}
    </>
  )
}
